export default __webpack_public_path__ + "static/media/Minicard_Td.62f67d3e.svg";